import React from 'react'
import { Router, Route, Switch, Link } from 'wouter'

export function TestEui() {
  return <p>Example</p>
}

export function Customers() {
  return (
    <Switch>
      <Route path="/customers/a">Hola AAAAA</Route>
      <Route path="/customers/b">Hola BBB</Route>
      <Route path="/customers/:rest*">
        <TestEui />
      </Route>
    </Switch>
  )
}
